<template>
  <div>
    <div class="margin10 center">干预前脑电波原始数据</div>
    <div id="beferRaw" style="height: 260px"></div>
    <div class="margin10 center">干预前脑电波测评数据</div>
    <div id="befer" style="height: 260px"></div>
    <div class="page"></div>
    <MyTable
      class="margin10"
      :th="['波段', '振幅值', '节律性', '峰值']"
      :data="beferData"
    ></MyTable>
    <DashedLine></DashedLine>
    <div class="margin10 center">干预后脑电波原始数据</div>
    <div id="afterRaw" style="height: 260px"></div>
    <div class="margin10 center">干预后脑电波测评数据</div>
    <div id="after" style="height: 260px"></div>
    <div class="page"></div>
    <MyTable
      class="margin10"
      :th="['波段', '振幅值', '节律性', '峰值']"
      :data="afterData"
    ></MyTable>
    <DashedLine></DashedLine>

    <div class="foot-text">
      <div class="caption">三角波、德尔塔波（Delta Waves，δ波）：</div>
      <div>频率范围：0.5赫兹以下（通常为0.5-4赫兹）。</div>
      <div>
        特点：三角波是最慢的脑电波，通常在深度非常睡眠时出现。它们通常在大脑清醒状态下不活跃，但在非快速眼动睡眠（NREM）阶段的第三和第四阶段最为活跃。这些波形指示深度睡眠、生长和修复身体组织的过程。
      </div>
      <div class="caption">缓波、希塔波（Theta Waves，θ波）：</div>
      <div>频率范围：4-8赫兹。</div>
      <div>
        特点：缓波通常与非常深度的放松状态、冥想、梦境和创造性思维有关。它们在清醒状态下也可出现，但通常不是主导波。
      </div>
      <div class="caption">阿尔法波（Alpha Waves，α波）：</div>
      <div>频率范围：8-12赫兹。</div>
      <div>
        特点：阿尔法波通常在放松、闭目休息时出现，特别是在清醒但不专注于特定任务时。它们常出现在颞叶和枕叶区域，被认为与放松、冥想和注意力的转移有关。
      </div>
      <div class="caption">贝塔波（Beta Waves，β波）：</div>
      <div>频率范围：12-30赫兹。</div>
      <div>
        特点：贝塔波通常在清醒状态下、进行认知任务、思考、注意力集中和决策制定时出现。较高的贝塔波频率与更高的警觉度和认知负荷有关。
      </div>
      <div class="caption">伽马波（Gamma Waves，γ波）：</div>
      <div>频率范围：30赫兹以上。</div>
      <div>
        特点：伽马波是最高频率的脑电波，通常与高级认知功能、记忆、学习、创造性思维和意识整合有关。它们的活跃性可能与信息处理和大脑功能协调有关。
      </div>
    </div>
    <div class="foot-text">
      <div>
        <span class="title">振幅：</span>
        脑电波的振幅是指脑电图（Electroencephalogram,
        EEG）记录中波形的峰值或振动的大小。脑电图是一种生理学技术，通过在头皮上放置电极来测量脑电活动的电位变化。这些电位变化由大脑中数以百万计的神经元活动引起，因此脑电图可以反映大脑电活动的模式。脑电波的振幅通常以微伏（μV）为单位来表示，它表示了电位变化的强度或振动的幅度。可以提供关于大脑活动的强度和兴奋水平的信息。更大的振幅通常表示更强烈的神经元活动，而较小的振幅可能表示较弱的兴奋。因此，振幅是分析脑电图以理解大脑状态、认知任务、情绪以及潜在疾病或异常的重要指标之一。
      </div>
      <div>
        <span class="title"> 节律性：</span>
        脑电波的节律性指的是它们在时间上呈现出的规则和重复的波动模式。这是由大脑中神经元的协调活动所产生，这些神经元通过同步地放电来生成可观察的电位变化。这种同步放电导致脑电波在不同频率范围内呈现不同的节律性。脑电波的节律性对于了解大脑功能和状态非常重要。不同的脑电波频率对应于不同的认知任务、情绪状态和大脑功能。因此，通过分析脑电波的节律性，可以获取有关个体的警觉度、放松度、认知任务的难度和情感状态的信息。
      </div>
      <div>
        <span class="title">尖峰数：</span>
        指在脑电图记录中某个特定频率范围内的波峰的数量。脑电波的尖峰数提供了有关大脑在不同频率下的活动情况的信息。它可以用来确定大脑在特定频率范围内的兴奋水平以及响应不同任务和情境的变化。尖峰数的变化可能反映大脑状态的改变，包括警觉度、认知任务的性质、情感状态以及可能的异常情况。
      </div>
    </div>
    <div class="page"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import DashedLine from "../dashedline.vue";
import band from "@/common/band.js";
export default {
  components: {
    DashedLine,
  },
  data() {
    return {
      band: band,
      beferData: [],
      afterData: [],
    };
  },
  computed: {
    ReportData() {
      return this.$store.state.ReportData;
    },
    zh() {
      return this.ReportData.zhReportHistories || {};
    },
  },
  watch: {
    zh(data) {
      this.init(data);
      this.getData(data);
    },
  },
  mounted() {},
  methods: {
    init(data) {
      this.$nextTick(() => {
        let commonOption = {
          legend: {},
          grid: {
            left: 80,
            right: 20,
            top: 30,
            bottom: 30,
          },
          xAxis: {
            type: "category",
          },
          yAxis: {
            type: "value",
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: "rgb(246, 255, 250)",
              },
            },
          },
        };
        let beferRawY = data.beferRawData.split(",");
        let beferRawX = beferRawY.map((m) => {
          return "";
        });
        let beferRaw = echarts.init(document.getElementById("beferRaw"));
        beferRaw.setOption({
          ...commonOption,
          color: ["#f38a1a"],
          xAxis: {
            data: beferRawX,
          },
          series: [
            {
              name: "原始",
              data: beferRawY,
              type: "line",
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 1,
              },
            },
          ],
        });

        let beferX = [];
        let beferY = this.band.map((m) => {
          return {
            key: m.key,
            name: m.label,
            data: [],
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
            },
          };
        });
        data.beferList.forEach((item) => {
          beferX.push(this.$dateformat(item.dataTime, "HH:mm:ss"));
          this.band.forEach((b) => {
            let yItem = beferY.find((f) => f.key == b.key);
            yItem.data.push(item[b.key]);
          });
        });

        let befer = echarts.init(document.getElementById("befer"));
        befer.setOption({
          ...commonOption,
          color: [
            "#647ecb",
            "#92e16d",
            "#ffd570",
            "#ff6f6c",
            "#79d3f6",
            "#00c688",
            "#f38a1a",
            "#ab4bd7",
          ],
          xAxis: {
            data: beferX,
          },
          series: beferY,
        });

        let afterRawY = data.afterRawData.split(",");
        let afterRawX = afterRawY.map((m) => {
          return "";
        });
        let afterRaw = echarts.init(document.getElementById("afterRaw"));
        afterRaw.setOption({
          ...commonOption,
          color: ["#f38a1a"],
          xAxis: {
            data: afterRawX,
          },
          series: [
            {
              name: "原始",
              data: afterRawY,
              type: "line",
              smooth: true,
              showSymbol: false,
              lineStyle: {
                width: 1,
              },
            },
          ],
        });

        let afterX = [];
        let afterY = this.band.map((m) => {
          return {
            key: m.key,
            name: m.label,
            data: [],
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
            },
          };
        });
        data.afterList.forEach((item) => {
          afterX.push(this.$dateformat(item.dataTime, "HH:mm:ss"));
          this.band.forEach((b) => {
            let yItem = afterY.find((f) => f.key == b.key);
            yItem.data.push(item[b.key]);
          });
        });

        let after = echarts.init(document.getElementById("after"));
        after.setOption({
          ...commonOption,
          color: [
            "#647ecb",
            "#92e16d",
            "#ffd570",
            "#ff6f6c",
            "#79d3f6",
            "#00c688",
            "#f38a1a",
            "#ab4bd7",
          ],
          xAxis: {
            data: afterX,
          },
          series: afterY,
        });
      });
    },
    getData(data) {
      let beferProcessList = data.beferProcessList || [];
      let beferData = [];
      //0:振幅值1:节律性2:峰值数
      this.band.forEach((b) => {
        let item0 = beferProcessList.find((f) => f.variationType == 0);
        let item1 = beferProcessList.find((f) => f.variationType == 1);
        let item2 = beferProcessList.find((f) => f.variationType == 2);
        beferData.push([b.label, item0[b.key], item1[b.key], item2[b.key]]);
      });
      this.beferData = beferData;

      let afterProcessList = data.afterProcessList || [];
      let afterData = [];
      //0:振幅值1:节律性2:峰值数
      this.band.forEach((b) => {
        let item0 = afterProcessList.find((f) => f.variationType == 0);
        let item1 = afterProcessList.find((f) => f.variationType == 1);
        let item2 = afterProcessList.find((f) => f.variationType == 2);
        afterData.push([b.label, item0[b.key], item1[b.key], item2[b.key]]);
      });
      this.afterData = afterData;
    },
  },
};
</script>

<style scoped lang="scss">
.foot-text {
  font-size: 12px;
  margin: 15px;
  .caption {
    font-weight: 600;
    color: #333;
  }
  .title {
    color: red;
  }
}
</style>